// @flow
'use strict'

const union = require('folktale/adt/union/union')

const deriveMethods = require('dbsm-common/src/adt/deriveMethods')

/*::
import typeof { WixDataQueryResult } from 'wix-data-core'

export type QueryResultsData = {|
  items: Array<ExistingRecord>,
  totalCount: number,
  offset: number
|}

type QueryResultsPattern<A> = {|
  Empty: () => A,
  Results: QueryResultsData => A
|}

type Empty = {
  map(QueryResultsData => QueryResultsData): Empty;
  chain(QueryResultsData => QueryResults): Empty;
  filter(QueryResultsData => boolean): Empty;
  orElse(() => QueryResults): QueryResults;
  of(QueryResultsData): QueryResults;
  get(): QueryResultsData;
  matchWith<A>(QueryResultsPattern<A>): A;
}

type Results = {
  map(QueryResultsData => QueryResultsData): Results;
  chain(QueryResultsData => QueryResults): QueryResults;
  filter(QueryResultsData => boolean): QueryResults;
  orElse(() => QueryResults): QueryResults;
  of(QueryResultsData): QueryResults;
  get: () => QueryResultsData;
  matchWith<A>(QueryResultsPattern<A>): A;
}

export type QueryResults = Empty | Results

type IQueryResults = {
  Empty(): Empty;
  Results(Array<ExistingRecord>, number, number): Results;
  of(QueryResultsData): QueryResults;
  fromWixDataQueryResults(WixDataQueryResult, number): QueryResults;
}
*/
const QueryResultsADT /*: { Empty: () => Empty, Results: (items: Array<ExistingRecord>, totalCount: number, offset?: number) => Results } */ = union(
  'QueryResults',
  {
    Empty: () => ({}),
    Results: (items, totalCount, offset = 0) => ({ items, totalCount, offset })
  }
)

deriveMethods(QueryResultsADT, {
  chain: {
    Empty: function chain(fn) {
      return this
    },
    Results: function chain(fn) {
      return fn({
        items: this.items,
        totalCount: this.totalCount,
        offset: this.offset
      })
    }
  },

  map: {
    Empty: function map(fn) {
      return this
    },
    Results: function map(fn) {
      const { items, totalCount, offset } = fn({
        items: this.items,
        totalCount: this.totalCount,
        offset: this.offset
      })
      return QueryResultsADT.Results(
        items || this.items,
        totalCount || this.totalCount,
        offset || this.offset
      )
    }
  },

  filter: {
    Empty: function filter(fn) {
      return this
    },
    Results: function filter(fn) {
      return fn({
        items: this.items,
        totalCount: this.totalCount,
        offset: this.offset
      })
        ? this
        : QueryResultsADT.Empty()
    }
  },

  orElse: {
    Empty: function orElse(fn) {
      return fn()
    },
    Results: function orElse(fn) {
      return this
    }
  },

  get: {
    Empty: get,
    Results: get
  },

  of: {
    Empty: of,
    Results: of
  }
})

function of(
  { items, totalCount, offset } /*: QueryResultsData */
) /*: QueryResults */ {
  return totalCount > 0 && Array.isArray(items)
    ? QueryResultsADT.Results(items, totalCount, offset)
    : QueryResultsADT.Empty()
}

function fromWixDataQueryResults(
  wixDataQueryResults /*: WixDataQueryResult */,
  offset /*: number */
) /*: QueryResults */ {
  return wixDataQueryResults
    ? this.of({
        items: wixDataQueryResults.items,
        totalCount: wixDataQueryResults.totalCount,
        offset
      })
    : QueryResultsADT.Empty()
}

function get() {
  return this.matchWith({
    Empty: () => ({ items: [], totalCount: 0, offset: 0 }),
    Results: results => results
  })
}

const exported /*: IQueryResults */ = {
  Empty: QueryResultsADT.Empty,
  Results: QueryResultsADT.Results,
  fromWixDataQueryResults,
  of
}

module.exports = exported



// WEBPACK FOOTER //
// ./helpers/queryResults.js